import { render, staticRenderFns } from "./artwork.vue?vue&type=template&id=cb5a43a2&scoped=true&"
import script from "./artwork.vue?vue&type=script&lang=js&"
export * from "./artwork.vue?vue&type=script&lang=js&"
import style0 from "./artwork.vue?vue&type=style&index=0&id=cb5a43a2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5a43a2",
  null
  
)

export default component.exports